import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: ReactNode;
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center animate-fadeIn">
      <div className="w-16 h-16 bg-surface-container-high rounded-full flex items-center justify-center mb-6 text-primary">
        <Icon size={32} />
      </div>
      <h3 className="text-lg font-headline font-semibold text-on-surface mb-2">{title}</h3>
      <p className="text-sm font-body text-on-surface-variant max-w-xs mb-8">{description}</p>
      {action && <div className="flex justify-center">{action}</div>}
    </div>
  );
}
